import { useMemo } from 'react';
import { useAppSelector } from '@/core/global-store';

/** Platform owner — manages subscriptions across all tenants. */
export function useIsOwner(): boolean {
    const user = useAppSelector((s) => s.auth.user);
    const me = useAppSelector((s) => s.auth.me);

    return useMemo(() => {
        if (user?.role === 'owner') {
            return true;
        }
        const roles = (me as Record<string, unknown> | null)?.roles as
            | Array<{ name?: string; slug?: string }>
            | undefined;
        if (!Array.isArray(roles)) {
            return false;
        }
        return roles.some((r) => r.slug === 'owner' || r.name === 'owner');
    }, [user?.role, me]);
}
